<ion-header
  class="ion-no-border ion-header-modal-mobile"
  [ngClass]="!isDiscardEdits ? 'ion-header-modal-mobile-shadow' : ''"
>
  <ion-toolbar>
    <ion-label data-cy="submit-mobile-order-label">
      {{
        (isDiscardEdits
          ? 'i18n.orderPage.areYouSure'
          : 'i18n.orderPage.submitAllOrders'
        ) | translate
      }}
    </ion-label>
  </ion-toolbar>
  <div class="submit-modal-mobile-order-info" *ngIf="!isDiscardEdits">
    <div data-cy="submit-mobile-order-total-label" class="order-total">
      <p>
        {{ 'i18n.orderPage.orderTotal' | translate }}
      </p>
      <p
        *ngIf="
          !vm?.orderHeader?.priceChangeFlag &&
          selectedCustomer?.ogPrintPriceInd !== 'N'
        "
        data-cy="submit-mobile-order-total-price-label"
      >
        {{ totalPrice$ | async | currency }}
      </p>
      <p
        *ngIf="
          vm?.orderHeader?.priceChangeFlag &&
          selectedCustomer?.ogPrintPriceInd !== 'N'
        "
        data-cy="submit-mobile-order-total-price-text"
      >
        {{ vm?.orderTallies?.totalPrice | currency }}
      </p>
      <p
        data-cy="submit-mobile-order-na-label"
        *ngIf="selectedCustomer?.ogPrintPriceInd === 'N'"
      >
        {{ 'i18n.orderPage.notApplicable' | translate }}
      </p>
    </div>
    <div class="order-total-info">
      <p data-cy="submit-mobile-order-shipment-info-text">
        {{ vm?.shipments?.length || 0 }}
        {{ 'i18n.orderPage.shipment' | translate
        }}{{ vm?.shipments?.length === 1 ? '' : 's' }}
        {{ 'i18n.orderPage.of' | translate }}
        {{ vm?.orderItemState?.ids?.length || 0 }}
        {{ 'i18n.orderPage.product' | translate
        }}{{ vm?.orderItemState?.tallies?.totalItems === 1 ? '' : 's' }} ({{
          vm?.orderItemState?.tallies?.totalCases || 0
        }}
        {{ 'i18n.orderPage.cs' | translate }} /
        {{ vm?.orderItemState?.tallies?.totalEaches || 0 }}
        {{ 'i18n.orderPage.ea' | translate }})
      </p>

      <div
        class="order-po-section"
        data-cy="po-number-mobile-orders-number-text"
      >
        <p translate class="ion-margin-vertical-half" data-cy="po-number-text">
          <span>
            {{ 'i18n.orderPage.poNumberFullText' | translate
            }}<span class="required-span" *ngIf="isCustomerRequirePO">*</span
            >:</span
          >
          <a
            #poNumberRef
            data-cy="add-change-link"
            *ngIf="
              vm?.orderHeader?.purchaseOrderNumber &&
              vm?.orderHeader?.purchaseOrderNumber?.trim().length !== 0
            "
            (click)="!isPoDisabledForPunchOut && presentChangePOPopover()"
            [class.disabled]="isPoDisabledForPunchOut"
            class="add-change-link"
            >{{ vm?.orderHeader?.purchaseOrderNumber }}
          </a>
          <a
            data-cy="add-change-link"
            *ngIf="
              !!vm?.orderHeader &&
              (!vm?.orderHeader?.purchaseOrderNumber ||
                vm?.orderHeader?.purchaseOrderNumber?.trim().length === 0)
            "
            (click)="!isPoDisabledForPunchOut && presentChangePOPopover()"
            [class.disabled]="isPoDisabledForPunchOut"
            class="add-change-link"
            >{{ 'i18n.common.edit' | translate }}
          </a>
        </p>
        <div
          *ngIf="
            isCustomerRequirePO &&
            (!vm?.orderHeader?.purchaseOrderNumber ||
              vm?.orderHeader?.purchaseOrderNumber?.trim().length === 0)
          "
          class="required-field-error-message"
        >
          {{ 'i18n.common.requiredFieldText' | translate }}
        </div>
      </div>

      <div
        data-cy="shipping-savings"
        *ngIf="this.vm?.orderTallies?.totalDirectShipmentSavings"
      >
        <p>
          {{ 'i18n.orderPage.totalShippingSavings' | translate }}
          {{
            this.vm?.orderTallies?.totalDirectShipmentSavings
              | currency: '$' : 'symbol' : '1.2-2'
          }}*
        </p>
      </div>
    </div>
  </div>
</ion-header>

<ion-content class="ion-content-modal-mobile">
  <div class="discard-msg" *ngIf="isDiscardEdits">
    <p>{{ 'i18n.orderPage.confirmDiscardOrderSubTitle' | translate }}</p>
  </div>
  <ng-container *ngIf="!isDiscardEdits">
    <div
      *ngFor="let shipment of vm?.shipments"
      class="submit-modal-orders-list-item"
    >
      <div class="orders-list-item-top">
        <div
          *ngIf="
            shipment?.shipmentType === 'routed' &&
              isProntoDay(shipment?.deliveryDate?.toString());
            else originalHeader
          "
        >
          <p data-cy="submit-mobile-order-pronto-delivery-date-text">
            {{ 'i18n.orderPage.prontoOrderBy' | translate }}&nbsp;
            {{ shipment.deliveryDate | date: 'shortDate' : 'GMT' }}
          </p>
        </div>
        <ng-template #originalHeader>
          <div>
            <p
              *ngIf="shipment.shipmentType === 'routed'"
              data-cy="submit-mobile-order-routed-delivery-date-text"
            >
              {{ 'i18n.orderPage.usFoodsOrderBy' | translate }}&nbsp;
              {{
                (vm?.orderHeader?.orderStatus === 'SUBMITTED' ||
                vm?.orderHeader?.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
                vm?.orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS'
                  ? vm?.orderHeader?.confirmedDeliveryDate
                  : shipment.deliveryDate
                ) | date: 'M/d/yyyy' : 'GMT'
              }}
            </p>
            <p
              *ngIf="shipment.shipmentType === 'vendor'"
              data-cy="submit-mobile-order-vendor-delivery-date-text"
            >
              {{ 'i18n.orderPage.directOrderBy' | translate }}&nbsp;
              {{
                (vm?.orderHeader?.orderStatus === 'SUBMITTED' ||
                vm?.orderHeader?.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
                vm?.orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS'
                  ? vm?.orderHeader?.confirmedDeliveryDate
                  : shipment.deliveryDate
                ) | date: 'M/d/yyyy' : 'GMT'
              }}
            </p>
          </div>
        </ng-template>
        <div>
          <p
            *ngIf="selectedCustomer?.ogPrintPriceInd !== 'N'; else noPrice"
            data-cy="submit-mobile-order-total-price-text"
          >
            {{ shipment.shipmentTallies?.totalPrice | currency }}
          </p>
          <ng-template #noPrice>
            <p data-cy="submit-mobile-order-no-price-label">
              {{ 'i18n.orderPage.notApplicable' | translate }}
            </p>
          </ng-template>
        </div>
      </div>
      <div class="orders-list-item-bottom">
        <p data-cy="submit-mobile-order-product-info-text">
          {{ shipment?.cartItems?.length || 0 }}
          {{ 'i18n.orderPage.mobileProducts' | translate }} ({{
            shipment?.shipmentTallies?.totalCases
          }}
          {{ 'i18n.orderPage.cs' | translate }} /
          {{ shipment?.shipmentTallies?.totalEaches }}
          {{ 'i18n.orderPage.ea' | translate }})
          <ng-container
            data-cy="submit-mobile-order-routed-info-text"
            *ngIf="shipment.shipmentType === 'routed'"
          >
            | {{ 'i18n.orderPage.orderWeight' | translate }}
            {{ shipment?.shipmentTallies?.orderWeight | number: '1.1-2' }}
            {{ 'i18n.orderPage.lb' | translate }}
          </ng-container>
        </p>

        <div
          *ngIf="
            shipment.shipmentType === 'vendor' &&
            shipment?.shipmentTallies?.totalDirectShipmentSavings
          "
          data-cy="shipping-savings"
        >
          <p>
            {{ 'i18n.orderPage.shippingSavings' | translate }}
            {{
              shipment?.shipmentTallies?.totalDirectShipmentSavings
                | currency: '$' : 'symbol' : '1.2-2'
            }}
          </p>
        </div>
      </div>
    </div>
    <div
      *ngIf="this.vm?.orderTallies?.totalDirectShipmentSavings"
      data-cy="submit-mobile-shipping-savings-note-text"
      class="shipping-savings-note"
    >
      <p>{{ 'i18n.orderPage.shippingSavingsAsterisk' | translate }}</p>
    </div>
  </ng-container>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        *ngIf="!isDiscardEdits"
        id="cancel-order-btn"
        data-cy="submit-mobile-order-cancel-button"
        [disabled]="enableSubmitButton$ | async"
        class="usf-outline-green-mobile-modal-button"
        (click)="cancelOrder()"
      >
        {{
          (vm?.shipments?.length > 1
            ? 'i18n.orderPage.cancelOrders'
            : 'i18n.orderPage.cancelOrder'
          ) | translate
        }}
      </ion-button>

      <ion-button
        *ngIf="isDiscardEdits"
        id="cancel-order-btn"
        data-cy="submit-mobile-order-cancel-button"
        [disabled]="enableSubmitButton$ | async"
        class="usf-outline-green-mobile-modal-button"
        (click)="discardCurrentEdits(false)"
      >
        {{ 'i18n.orderPage.cancel' | translate }}
      </ion-button>

      <ion-button
        *ngIf="isDiscardEdits"
        id="discard-edits-btn"
        data-cy="submit-mobile-discard-edits-button"
        class="usf-fill-green-button"
        (click)="discardCurrentEdits(true)"
      >
        {{ 'i18n.orderPage.discardEdits' | translate }}
      </ion-button>

      <ion-button
        *ngIf="vm?.shipments?.length > 0 && !isDiscardEdits"
        id="submit-order-btn"
        data-cy="submit-mobile-order-submit-button"
        [disabled]="enableSubmitButton$ | async"
        [ngClass]="
          (enableSubmitButton$ | async) ||
          (isCustomerRequirePO &&
            (!vm?.orderHeader?.purchaseOrderNumber ||
              vm?.orderHeader?.purchaseOrderNumber?.trim().length === 0))
            ? 'usf-fill-disabled-button'
            : 'usf-fill-green-button'
        "
        (click)="submitOrder()"
      >
        {{
          vm?.submitButtonText
            ? vm.submitButtonText
            : ((vm?.shipments?.length > 1
                ? 'i18n.orderPage.submitOrders'
                : 'i18n.orderPage.submitOrder'
              ) | translate)
        }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
